<template>
  <md-notice-bar class="noticetop" type="warning" mode="closable" icon="info" multi-rows v-if="shownotice"
    @close="closenotice">
    <div @click="showmessage">
      {{ content }}
    </div>
  </md-notice-bar>
</template>
  
<script>
import { unreadcount } from '@/request/api'
export default {
  name: 'noticetop',
  data() {
    return {
      content: "Welcome, Please pay attention to the notice here!",
      notificationevent: null,
      shownotice: false
    }
  },
  watch: {},
  created() {
    let that = this;
    if (this.notificationevent != null) {
      clearInterval(this.notificationevent);
    }
    if(localStorage.getItem('token')) {
      this.unreadcount();
    }
    this.notificationevent = setInterval(() => {
      if(localStorage.getItem('token')) {
        that.unreadcount();
      }
    }, 15000);
  },
  methods: {
    showmessage() {
      this.$router.push({ name: 'message' });
    },
    closenotice() {
      console.log("close");
      this.shownotice = false;
      return true;
    },
    unreadcount() {
      this.$store.dispatch('asyncupdateunreadcount').then(unread_count=>{
        if(unread_count > 0) {
          this.content = "You have " + unread_count + " unread messages, please check it!";
          this.shownotice = true;
        }
      });
    },

  },
  beforeDestroy() {
    if (this.notificationevent != null) {
      clearInterval(this.notificationevent);
    }
  }
}
</script>
<style scoped>
.noticetop {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  z-index: 999;
  position: fixed;
  padding-left: 0.32rem;
  box-sizing: border-box;
  background-color: #ffedde;
  color: #ff843d;
}
</style>



// WEBPACK FOOTER //
// src/components/noticetop.vue